import startCase from "lodash/startCase";
import { formatBytes } from "../../utils";
export var PreviewSessionFields = {
    id: {
        label: "ID",
        type: "stringWithCopy",
    },
    type: {
        label: "Type",
        getValue: function (data) {
            var _a;
            return startCase((_a = data.type) !== null && _a !== void 0 ? _a : "");
        },
    },
    name: {
        label: "Name",
    },
    size: {
        label: "Size",
        getValue: function (data) {
            var value = data.size;
            try {
                if (!isNaN(value !== null && value !== void 0 ? value : 0)) {
                    var numValue = Number(value);
                    if (typeof numValue === "number") {
                        value = formatBytes(numValue);
                    }
                }
            }
            catch (_a) { }
            return value;
        },
        hideIfUndefined: true,
    },
    format: {
        label: "Format",
        hideIfUndefined: true,
    },
    mimetype: {
        label: "MIME Type",
        hideIfUndefined: true,
    },
    "scan-verdict": {
        label: "File Scan result",
        hideIfUndefined: true,
    },
    parent_id: {
        label: "Folder ID",
        type: "stringWithCopy",
        hideIfUndefined: true,
    },
    path: {
        label: "Path",
        hideIfUndefined: true,
    },
    created_at: {
        label: "Created at",
        type: "dateTime",
    },
    updated_at: {
        label: "Modified at",
        type: "dateTime",
    },
    advanced: {
        label: "Advanced",
        type: "grouping",
        isHidden: function (data) {
            return (data === null || data === void 0 ? void 0 : data.tags) === undefined && (data === null || data === void 0 ? void 0 : data.metadata) === undefined;
        },
        fields: {
            tags: {
                label: "Tags",
                type: "stringArray",
                hideIfUndefined: true,
            },
            metadata: {
                label: "Custom metadata",
                LabelProps: {
                    placement: "top",
                },
                type: "json",
                isPrimary: true,
                hideIfUndefined: true,
            },
        },
    },
};
